/**
 * Cookie plugin (as-is)
 */
jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/**
 * Module to show Recently Viewed Products
 */
Shopify = window.Shopify || {};
Shopify.Products = (function() {

  // ================= helpers =================
  function normalizeHandle(input) {
    if (!input) return "";
    try {
      var s = String(input);
      // /products/ を含まないならハンドル前提で一旦連結
      var a = document.createElement('a');
      a.href = s.indexOf('/products/') === 0 ? s : ('/products/' + s);
      var m = a.pathname.match(/^\/products\/([^\/?#]+)/i);
      return m ? decodeURIComponent(m[1]).toLowerCase() : "";
    } catch(e) {
      return String(input).split(/[\/?#]/)[0].toLowerCase();
    }
  }
  function uniqueStrings(arr) {
    var out = [], seen = Object.create(null);
    for (var i=0; i<(arr||[]).length; i++) {
      var v = String(arr[i] || "");
      if (v && !seen[v]) { seen[v] = true; out.push(v); }
    }
    return out;
  }
  function sanitizeList(arr, limit) {
    var cleaned = uniqueStrings(arr).map(normalizeHandle).filter(Boolean);
    cleaned = uniqueStrings(cleaned);
    if (typeof limit === "number" && limit > 0) cleaned = cleaned.slice(0, limit);
    return cleaned;
  }
  // scriptテンプレートの href/src を data-* に置換（テンプレート自体を編集せずにSEO誤検知を回避）
  function rewriteTemplateToDataAttrs($tpl) {
    if (!$tpl || !$tpl.length) return;
    var html = $tpl.html() || "";
    // 既に data-href / data-src の場合はそのまま
    html = html.replace(/\shref="/gi, ' data-href="').replace(/\ssrc="/gi, ' data-src="');
    $tpl.html(html);
  }
  // data-* → 本属性へ（描画後に適用）
  function activateAttrs(scope) {
    jQuery(scope).find('a[data-href]').each(function() {
      if (!this.getAttribute('href')) this.setAttribute('href', this.getAttribute('data-href'));
    });
    jQuery(scope).find('img[data-src]').each(function() {
      if (!this.getAttribute('src')) this.setAttribute('src', this.getAttribute('data-src'));
    });
  }
  // DOM重複排除（URLキー）
  function keyFromUrl(u) {
    try {
      var url = new URL(u, location.origin);
      var path = url.pathname.replace(/\/+$/, '');
      return path.toLowerCase(); // 例: /products/handle
    } catch(e) {
      var a = document.createElement('a');
      a.href = u;
      var path = (a.pathname || '').replace(/\/+$/, '');
      return (path || u).toLowerCase();
    }
  }
  function dedupeSlides(container) {
    if (!container) return;
    var seen = Object.create(null);
    var slides = container.querySelectorAll('.swiper-slide');
    Array.prototype.forEach.call(slides, function(slide) {
      var a = slide.querySelector('a');
      if (!a) return;
      var href = a.getAttribute('href') || a.getAttribute('data-href') || '';
      if (!href) return;
      var key = keyFromUrl(href);
      if (seen[key]) {
        slide.parentNode && slide.parentNode.removeChild(slide);
      } else {
        seen[key] = true;
      }
    });
  }

  // =============== original module ===============
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 40,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: { expires: 90, path: '/', domain: window.location.hostname },
    write: function(name, arr) { jQuery.cookie(name, arr.join(' '), this.configuration); },
    read: function(name) {
      var out = [], val = jQuery.cookie(name);
      if (val !== null) out = val.split(' ');
      return out;
    },
    destroy: function() { jQuery.cookie(this.name, null, this.configuration); },
    remove: function(name, handle) {
      var list = this.read(name);
      var pos = jQuery.inArray(handle, list);
      if (pos !== -1) { list.splice(pos, 1); this.write(name, list); }
    }
  };

  var finalize = function() {
    wrapper.show();
    var historySwiper = new Swiper('.js-history-caroucel', {
      loop: false,
      slidesPerView: "auto",
      freeMode: true,
      navigation: { nextEl: '.swiper-history-button-next', prevEl: '.swiper-history-button-prev' }
    });
    // 必要なら外から update() できるように
    window.historySwiper = historySwiper;

    // 描画後の最終整形
    var target = document.getElementById(config.wrapperId);
    activateAttrs(target || document);
    dedupeSlides(target);
    if (window.historySwiper && typeof window.historySwiper.update === 'function') {
      window.historySwiper.update();
    }

    if (!config.onComplete) {
      try { config.onComplete = true; /* config.onComplete(); */ } catch (e) {}
    }
  };

  var moveAlong = function(name) {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      // カタログ除外
      if (productHandleQueue[0].indexOf("catalog_") === 0) {
        productHandleQueue.shift();
        moveAlong(name);
        return;
      }
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function(product) {
          // jQuery.tmpl で挿入
          var $nodes = template.tmpl(product).appendTo(wrapper);
          // data-* → 属性へ
          activateAttrs($nodes);
          // スライド重複除去
          dedupeSlides(wrapper[0]);
          // 次へ
          productHandleQueue.shift();
          shown++;
          moveAlong(name);
        },
        error: function() {
          cookie.remove(name, productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong(name);
        }
      });
    } else {
      finalize();
    }
  };

  return {

    resizeImage: function(src, size) {
      if (src == null) return null;
      if (size == null) return src;
      if (size == 'master') return src.replace(/http(s)?:/, "");
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },

    showRecentlyViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      // Cookieをクリーン化して読み込み
      productHandleQueue = sanitizeList(cookie.read('shopify_recently_viewed'), config.howManyToStoreInMemory);

      // テンプレート/挿入先
      template = jQuery('#' + config.templateId);
      wrapper  = jQuery('#' + config.wrapperId);

      // テンプレートの href/src を data-* に書き換え（1回でOK）
      rewriteTemplateToDataAttrs(template);

      // 表示件数
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      if (config.howManyToShow && template.length && wrapper.length) {
        moveAlong('shopify_recently_viewed');
      }
    },

    showRecentlyMemorialViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      productHandleQueue = sanitizeList(cookie.read('shopify_recently_memorial_viewed'), config.howManyToStoreInMemory);

      template = jQuery('#recently-viewed-memorials-template');
      wrapper  = jQuery('#recently-viewed-memorials');

      rewriteTemplateToDataAttrs(template);

      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      if (config.howManyToShow && template.length && wrapper.length) {
        moveAlong('shopify_recently_memorial_viewed');
      }
    },

    showDocumentRequest: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      productHandleQueue = sanitizeList(cookie.read('shopify_document_request'), config.howManyToStoreInMemory);

      template = jQuery('#document-request-template');
      wrapper  = jQuery('#document-request');

      rewriteTemplateToDataAttrs(template);

      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      if (config.howManyToShow && template.length && wrapper.length) {
        moveAlong('shopify_document_request');
      }
    },

    getRecentlyViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);
      productHandleQueue = sanitizeList(cookie.read('shopify_recently_viewed'), config.howManyToStoreInMemory);
      return productHandleQueue;
    },

    getRecentlyMemorialViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);
      productHandleQueue = sanitizeList(cookie.read('shopify_recently_memorial_viewed'), config.howManyToStoreInMemory);
      return productHandleQueue;
    },

    getDocumentRequest: function(params) {
      params = params || {};
      jQuery.extend(config, params);
      productHandleQueue = sanitizeList(cookie.read('shopify_document_request'), config.howManyToStoreInMemory);
      return productHandleQueue;
    },

    getConfig: function() { return config; },

    clearList: function() { cookie.destroy(); },

    recordRecentlyViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      var list = sanitizeList(cookie.read('shopify_recently_viewed'), config.howManyToStoreInMemory);

      if (window.location.pathname.indexOf('/products/') !== -1) {
        var m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
        if (!m) return;
        var handle = normalizeHandle(m[1]);

        var pos = jQuery.inArray(handle, list);
        if (pos === -1) {
          list.unshift(handle);
          list = list.splice(0, config.howManyToStoreInMemory);
        } else {
          list.splice(pos, 1);
          list.unshift(handle);
        }
        list = sanitizeList(list, config.howManyToStoreInMemory);
        jQuery.cookie('shopify_recently_viewed', list.join(' '), cookie.configuration);
      }
    },

    recordRecentlyMemorialViewed: function(params) {
      params = params || {};
      jQuery.extend(config, params);

      var list = sanitizeList(cookie.read('shopify_recently_memorial_viewed'), config.howManyToStoreInMemory);

      if (window.location.pathname.indexOf('/products/') !== -1) {
        var m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
        if (!m) return;
        var handle = normalizeHandle(m[1]);

        var pos = jQuery.inArray(handle, list);
        if (pos === -1) {
          list.unshift(handle);
          list = list.splice(0, config.howManyToStoreInMemory);
        } else {
          list.splice(pos, 1);
          list.unshift(handle);
        }
        list = sanitizeList(list, config.howManyToStoreInMemory);
        jQuery.cookie('shopify_recently_memorial_viewed', list.join(' '), cookie.configuration);
      }
    },

    recordDocumentRequest: function(params, handle) {
      params = params || {};
      jQuery.extend(config, params);

      var requests = sanitizeList(cookie.read('shopify_document_request'), config.howManyToStoreInMemory);

      var h;
      if (handle) {
        h = normalizeHandle(handle);
      } else if (window.location.pathname.indexOf('/products/') !== -1) {
        var m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
        h = m ? normalizeHandle(m[1]) : "";
      }
      if (!h) return;

      var pos = jQuery.inArray(h, requests);
      if (pos === -1) {
        if (h.indexOf("catalog_") === 0) {
          requests.push(h);
        } else {
          requests.unshift(h);
          requests = requests.splice(0, config.howManyToStoreInMemory);
        }
      } else {
        requests.splice(pos, 1);
        if (h.indexOf("catalog_") === 0) {
          requests.push(h);
        } else {
          requests.unshift(h);
        }
      }
      requests = sanitizeList(requests, config.howManyToStoreInMemory);
      jQuery.cookie('shopify_document_request', requests.join(' '), cookie.configuration);
    },

    removeDocumentRequest: function(params, handle) {
      var h = handle || (function() {
        var m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
        return m ? normalizeHandle(m[1]) : "";
      })();
      if (!h) return;
      cookie.remove('shopify_document_request', h);
    }

  };

})();